import { useState } from 'react'
import { t } from '../utils/i18n'

const GroupedComponent = ({ children, name, count }) => {
  const [active, setActive] = useState(false)
  if (count === 0) return null
  return (
    <div
      className={`velorbis-grouped-component${
        active ? ' velorbis-grouped-component--active' : ''
      }`}
    >
      <div
        className="velorbis-grouped-component__head"
        onClick={() => setActive(!active)}
      >
        <span>{t(name)}</span>
        <span
          className={
            active
              ? 'velorbis-grouped-component__head__arrow velorbis-grouped-component__head__arrow--rotate'
              : 'velorbis-grouped-component__head__arrow velorbis-grouped-component__head__arrow'
          }
        >
          &#x25BE;
        </span>
      </div>
      <div
        className={`velorbis-grouped-component__items${
          !active ? ' velorbis-grouped-component__items--hidden' : ''
        }`}
      >
        {children}
      </div>
    </div>
  )
}

export default GroupedComponent
